import React, { useEffect } from "react";
import { NavLink } from 'react-router-dom';
import { Container, Grid } from '@material-ui/core';
import { IoIosArrowDropleft, IoIosMenu } from "react-icons/io";
import { MobileNav } from '../../layouts/components/header/Navbar/MobileNav';
import { FiChevronDown } from 'react-icons/fi';
import Branch from "../../models/branch.model";
import Preloader from "../../components/PreLoader";
import menu from "../../models/menu.model";
import { useDispatch, useSelector } from "react-redux";
import { loadDM } from "../../services/menu.service";
import { lang } from "../../config/app.config";
import translate from '../../translation.json';




const MN = new MobileNav('toggle-district-menu-button', 'ecn-district-navigation', 'district-child-menu', 'ecn-district-dropdown-toggle-icon');


interface state {
  menu: {
    districtMenu: menu,
    loadingDM: boolean,
  }
}

interface navProps {
  branch: Branch
}

const DistNav: React.FC<navProps> = (props) => {

  const dispatch = useDispatch();
  const { branch } = props;


  useEffect(() => {
    dispatch(loadDM('district-menu'))
  }, []);//eslint-disable-line

  useEffect(() => {
    MN.init();
  });//eslint-disable-line




  // redux state
  const state = useSelector((state: state) => {
    const { menu } = state;
    return menu;
  })

  const { districtMenu, loadingDM } = state;

  return (
    <>

      <nav className="ech-navbar-invert" id="ecn-navbar">
        <Container maxWidth="lg">
          <Grid container>
            <Grid item xs={6} md={9}>
              {/* <ul>
          <li className="navigation-list" id="toggle-district-menu-button">
            <span className="text-14-primary mr-2">{branch?.district || ""} Menu</span><IoIosMenu/>
          </li>
        </ul>
        <h3 className="text-14-primary dist-title">{branch?.district || ""} Menu</h3> */}
              <ul>
                <li className="navigation-list" id="toggle-district-menu-button">
                  <IoIosMenu />
                </li>
              </ul>
              <div className="menu-backdrop" onClick={() => MN.closeMenu()}></div>
              <ul className="navigation" id="ecn-district-navigation">
                <li className="navigation-list close-menu" onClick={() => MN.closeMenu()}>
                  <IoIosArrowDropleft /><span>Close menu</span>
                </li>
                {
                  !loadingDM ?
                    districtMenu && districtMenu.children.length ?

                      districtMenu.children.map((m, i) => (
                        <li className="navigation-list" key={i}>
                          <NavLink to={'/' + lang + m.key + branch?.slug} exact onClick={() => MN.closeMenu()} activeClassName="active" >
                            <span className="display-flex align-item-center">
                              {m.name || ""}
                            </span>
                          </NavLink>
                          {m.children && m.children.length ? <FiChevronDown className="ecn-district-dropdown-toggle-icon" /> : ''}
                          {
                            m.children && m.children.length ?
                              <ul className="district-child-menu">
                                {
                                  m.children.map((child, i) => (
                                    <li key={i}>
                                      <NavLink to={'/' + lang + child.key + branch?.slug} exact onClick={() => MN.closeMenu()} activeClassName="active">
                                        <span>{child.name || ""}</span>
                                      </NavLink>
                                    </li>
                                  ))
                                }

                              </ul> : ''
                          }
                        </li>
                      ))
                      : '' // no menu children

                    : <Preloader />// loading
                }
              </ul>
            </Grid>
            <Grid item xs={6} md={3} className="display-flex  align-item-center" style={{ justifyContent: 'flex-end' }}>
              {/* <NavLink to={`/${lang}/page/voter-list`} className="voter-roll">{translate.translation[lang].voter_roll}</NavLink> */}
            </Grid>
          </Grid>
        </Container>
      </nav>
    </>
  );
}

export default DistNav;
